import { BlockerFunction } from "react-router-dom";

import usePrompt from "../usePrompt";

declare interface InitialStateType {
	isActive: boolean;
	state: "blocked" | "proceeding" | "unblocked";
	onConfirm(): void;
	onCancel(): void;
	blocker: ReturnType<typeof usePrompt>;
}

type UseConfirmProps = {
	when: boolean | BlockerFunction;
	disabled: boolean;
};
const useConfirm = ({ when, disabled = false }: UseConfirmProps): InitialStateType => {
	const blocker = usePrompt(when, disabled);

	const onCancel = () => {
		if (blocker.state === "blocked") {
			blocker.reset();
		}
	};

	const onConfirm = () => {
		if (blocker.state === "blocked" && when) {
			blocker.proceed();
		}
	};

	return {
		isActive: blocker.state === "blocked",
		state: blocker.state,
		onConfirm,
		onCancel,
		blocker,
	};
};

export default useConfirm;
